import { Fragment } from "react";
import { useState, useEffect, useCallback } from "react";
import logo from "./logo.svg";
import Field from "./Field";
import units from "./units";
import measures from "./measures";
import cloneDeep from "lodash/cloneDeep";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import "./App.css";
import "csshake/dist/csshake.css";

function App() {
  const [measureValues, setMeasureValues] = useState(["length", "time"]);
  const [fields, setFields] = useState([
    [
      { unit: "mile", value: 6 },
      { unit: "h", value: 1 },
    ],
    [
      { unit: "km", value: null, target: true },
      { unit: "mile", value: 1 },
    ],
  ]);
  const [logoClassName, setLogoClassName] = useState("");

  useEffect(() => {
    setFields((prev) => {
      const result = cloneDeep(prev);
      result.forEach((pair) =>
        pair.forEach((item, index) => {
          if (units[item.unit].measureId === measureValues[index]) return;

          item.unit = {
            time: "s",
            length: "m",
            mass: "kg",
            currency: "usd",
            volume: "liter",
          }[measureValues[index]];
        })
      );
      return result;
    });
  }, [measureValues]);

  useEffect(() => {
    const sourcePair = fields.find((pair) =>
      pair.every(({ target }) => !target)
    );
    const targetPair = fields.find((pair) => pair.some(({ target }) => target));
    const targetIndex = targetPair.findIndex(({ target }) => target);

    const dividendIndex = (targetIndex + 1) % 2;
    const answer =
      (targetPair[dividendIndex].value *
        units[targetPair[dividendIndex].unit].baseUnit *
        sourcePair[targetIndex].value *
        units[sourcePair[targetIndex].unit].baseUnit) /
      (sourcePair[dividendIndex].value *
        units[sourcePair[dividendIndex].unit].baseUnit) /
      units[targetPair[targetIndex].unit].baseUnit;
    setFields((prev) => {
      const result = cloneDeep(prev);
      const targetPair = result.find((pair) =>
        pair.some(({ target }) => target)
      );
      targetPair.forEach((item) => {
        if (item.target !== true) return;
        item.value = answer;
      });
      return result;
    });
  }, [
    fields
      .flat()
      .map(({ unit, value }) => [unit, value].join())
      .join(),
  ]);

  const handleClickLogo = useCallback(() => {
    setLogoClassName("shake shake-constant");
  }, []);

  useEffect(() => {
    if (logoClassName !== "shake shake-constant") return;
    setTimeout(() => setLogoClassName(""), 200);
  }, [logoClassName]);

  return (
    <main>
      <Container maxWidth="sm">
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box m={4} height={128}>
            <img
              src={logo}
              alt="logo"
              width="128"
              onClick={handleClickLogo}
              className={logoClassName}
            />
          </Box>
          <div className="App__grid">
            {measureValues.map((measureId, index) => (
              <Fragment key={index}>
                <FormControl variant="outlined">
                  <Select
                    native
                    value={measureId}
                    onChange={({ target: { value } }) =>
                      setMeasureValues((prev) => {
                        const result = [...prev];
                        result[index] = value;
                        return result;
                      })
                    }
                  >
                    {Object.values(measures).map(({ id, name }) => (
                      <option value={id} key={id}>
                        {name}
                      </option>
                    ))}
                  </Select>
                </FormControl>
                {index === 0 ? ":" : null}
              </Fragment>
            ))}
            {fields.map((pair, pairIndex) =>
              pair.map(({ unit, value, target }, index) => {
                return (
                  <Fragment key={index}>
                    <Field
                      readOnly={target}
                      value={value || ""}
                      onChange={({ target: { value } }) => {
                        setFields((prev) => {
                          const result = cloneDeep(prev);
                          result[pairIndex][index].value = value;
                          return result;
                        });
                      }}
                      options={Object.values(units)
                        .filter(
                          ({ measureId }) => measureId === measureValues[index]
                        )
                        .map(({ name, id: value }) => ({ name, value }))}
                      unitValue={unit}
                      onChangeUnit={({ target: { value } }) => {
                        setFields((prev) => {
                          const result = cloneDeep(prev);
                          result[pairIndex][index].unit = value;
                          return result;
                        });
                      }}
                    />
                    {index === 0 ? ":" : null}
                  </Fragment>
                );
              })
            )}
          </div>
        </Box>
      </Container>
    </main>
  );
}

export default App;
